import { Col, Row } from 'react-bootstrap';
import Blockquote from '../../../components/Blockquote';
import { formatPrice } from '../../../utils/utils';
import PopoverWithLinks from '../PopoverLinks/PopoverLinks';

const CurrentAccruedPension = ({
  currentAccruedPensionData,
  linksData,
  white = false,
}: any) => {
  return (
    <Row className="m-0 d-flex justify-content-between">
      <Row className={'m-0 p-0'}>
        <Col
          className={
            'p-0 d-flex justify-content-between align-items-center mb-10'
          }
        >
          <h4 className={'text-sm-20-lg-32 m-0 lh-xs'}>
            {'Current Accrued Pension'}
          </h4>

          <section className={'align-items-center'}>
            <PopoverWithLinks linksData={linksData} />
          </section>
        </Col>
      </Row>
      <Row className={'m-0 p-0'}>
        <Col
          className={`p-0 ${
            white ? 'bg-white rounded-1' : 'border rounded-1'
          } p-11`}
        >
          <Row className="m-0 px-6 px-lg-0 mb-5">
            <Row className="px-0 mx-0 mb-3 pb-3 border-bottom">
              <Col className="col-4 px-0 "></Col>
              <Col className="px-0 text-end text-sm-12-lg-14 fw-light text-ligther-grey">
                Balance
              </Col>{' '}
              <Col className="px-0 text-center text-sm-12-lg-14 fw-light text-ligther-grey">
                OR
              </Col>{' '}
              <Col className="px-0 text-end text-sm-12-lg-14 fw-light text-ligther-grey">
                Monthly Benefit
              </Col>
            </Row>
            {currentAccruedPensionData.map(
              (
                {
                  title,
                  subtitle,
                  monthlyBenefitPriceDescription,
                  balance,
                  monthlyBenefit,
                }: any,
                index: number
              ) => (
                <Row
                  key={index}
                  className={`${
                    currentAccruedPensionData.length !== index + 1
                      ? 'border-bottom'
                      : ''
                  } p-0 m-0`}
                >
                  <Col className="col-5">
                    <Row className="mt-5 text-sub1 text-indigo lh-xxs">
                      {title}
                    </Row>
                    <Row className="mb-3 text-caption text-dark-gray-50 fw-lighter lh-xxs">
                      {subtitle}
                    </Row>
                  </Col>
                  <Col className="px-0 text-end">
                    <Col
                      className={`mt-5 col-12 text-sub1 lh-xxs ${
                        !balance && 'text-center text-dark-gray-50'
                      }`}
                    >
                      {balance
                        ? `${formatPrice(Number(balance), 'en-US', {
                            currency: 'USD',
                            style: 'currency',
                            minimumFractionDigits: 0,
                          })}`
                        : 'n/a'}
                      {}
                    </Col>
                  </Col>
                  <Col></Col>

                  <Col className="px-0 text-end">
                    <Col className="mt-5 col-12 text-sub1 lh-xxs">
                      {`${formatPrice(Number(monthlyBenefit), 'en-US', {
                        currency: 'USD',
                        style: 'currency',
                        minimumFractionDigits: 0,
                      })}`}
                    </Col>
                    <Col className="mb-3 col-12 text-dark-gray-50 text-caption fw-light lh-xxs">
                      {monthlyBenefitPriceDescription}
                    </Col>
                  </Col>
                </Row>
              )
            )}
          </Row>
          {white && (
            <Row className={'m-0 p-0'}>
              <Blockquote>
                <>
                  <div className={'text-darker-gray-75'}>
                    <strong>Did you know?</strong>
                  </div>
                  <div className={'mt-1 text-ligther-grey'}>
                    If you don't make an election and you die the remaining
                    payment will be made first to your designated beneficiary
                    and if your beneficiary is dead then to your Estate.
                  </div>
                </>
              </Blockquote>
            </Row>
          )}
        </Col>
      </Row>
    </Row>
  );
};

export default CurrentAccruedPension;
